import React, { useEffect, useState, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ResultsSection } from './components/ResultsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PoweredBySection } from './components/PoweredBySection';
import { IncludedSection } from './components/IncludedSection';
import { DemosSection } from './components/DemosSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/SectionDivider';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { HowItWorksSection } from './components/HowItWorksSection';
import { LocalSeoContent } from './components/LocalSeoContent';
import { SchemaMarkup } from './components/SchemaMarkup';
// Service Pages
import { ElectricianWebsiteDublin } from './pages/ElectricianWebsiteDublin';
import { RestaurantWebsiteDublin } from './pages/RestaurantWebsiteDublin';
import { BarberWebsiteDublin } from './pages/BarberWebsiteDublin';
import { TradesWebsiteDublin } from './pages/TradesWebsiteDublin';
import { HotelWebsiteIreland } from './pages/HotelWebsiteIreland';
// Blog Pages
import { BlogIndex } from './pages/BlogIndex';
import { WebsiteCostIreland } from './pages/blog/WebsiteCostIreland';
import { WebsiteDesignDublinGuide } from './pages/blog/WebsiteDesignDublinGuide';
import { ElectricianWebsiteBlog } from './pages/blog/ElectricianWebsiteBlog';
import { RestaurantWebsiteDesignBlog } from './pages/blog/RestaurantWebsiteDesignBlog';
import { SeoSmallBusinessIreland } from './pages/blog/SeoSmallBusinessIreland';
function PageWrapper({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="pt-24 min-h-screen" data-id="element-0">
      {children}
      <SectionDivider data-id="element-1" />
      {/* Back to home CTA */}
      <div className="text-center py-12" data-id="element-2">
        <a href="/" onClick={e => {
        e.preventDefault();
        window.history.pushState({}, '', '/');
        window.dispatchEvent(new PopStateEvent('popstate'));
        window.scrollTo(0, 0);
      }} className="inline-flex items-center space-x-2 border border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c] hover:text-black px-6 py-3 rounded-lg font-medium transition-all duration-300" data-id="element-3">
          <span data-id="element-4">← Back to Home</span>
        </a>
      </div>
    </div>;
}
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  // Microsoft Clarity analytics
  useEffect(() => {
    ;
    (function (c: any, l: any, a: string, r: string, i: string, t?: any, y?: any) {
      c[a] = c[a] || function () {
        ;
        (c[a].q = c[a].q || []).push(arguments);
      };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'vnizee75ok');
  }, []);
  // Google Analytics (gtag.js)
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-3JM6MY3YFZ';
    document.head.appendChild(script);
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) {
      ;
      (window as any).dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-3JM6MY3YFZ');
  }, []);
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, {
      threshold: 0.1
    });
    // Small delay to ensure DOM is ready after route change
    const timer = setTimeout(() => {
      const hiddenElements = document.querySelectorAll('.reveal');
      hiddenElements.forEach(el => observer.observe(el));
    }, 50);
    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [currentPath]);
  const renderPage = () => {
    switch (currentPath) {
      // Service Pages
      case '/services/electrician-website-dublin':
        return <ElectricianWebsiteDublin data-id="element-5" />;
      case '/services/restaurant-website-dublin':
        return <RestaurantWebsiteDublin data-id="element-6" />;
      case '/services/barber-website-dublin':
        return <BarberWebsiteDublin data-id="element-7" />;
      case '/services/trades-website-dublin':
        return <TradesWebsiteDublin data-id="element-8" />;
      case '/services/hotel-website-ireland':
        return <HotelWebsiteIreland data-id="element-9" />;
      // Blog Pages
      case '/blog':
        return <BlogIndex data-id="element-10" />;
      case '/blog/website-cost-ireland-2026':
        return <WebsiteCostIreland data-id="element-11" />;
      case '/blog/website-design-dublin-small-businesses':
        return <WebsiteDesignDublinGuide data-id="element-12" />;
      case '/blog/electrician-website-dublin':
        return <ElectricianWebsiteBlog data-id="element-13" />;
      case '/blog/restaurant-website-design-ireland':
        return <RestaurantWebsiteDesignBlog data-id="element-14" />;
      case '/blog/seo-small-businesses-ireland':
        return <SeoSmallBusinessIreland data-id="element-15" />;
      // Existing Pages
      case '/results':
        return <PageWrapper title="Results" data-id="element-16">
            <ResultsSection data-id="element-17" />
          </PageWrapper>;
      case '/included':
        return <PageWrapper title="What You Get" data-id="element-18">
            <IncludedSection data-id="element-19" />
          </PageWrapper>;
      case '/demos':
        return <PageWrapper title="Demos" data-id="element-20">
            <DemosSection data-id="element-21" />
          </PageWrapper>;
      case '/pricing':
        return <PageWrapper title="Pricing" data-id="element-22">
            <PricingSection data-id="element-23" />
          </PageWrapper>;
      case '/faq':
        return <PageWrapper title="FAQ" data-id="element-24">
            <FaqSection data-id="element-25" />
          </PageWrapper>;
      case '/contact':
        return <PageWrapper title="Contact" data-id="element-26">
            <ContactSection data-id="element-27" />
          </PageWrapper>;
      case '/how-it-works':
        return <PageWrapper title="How It Works" data-id="element-28">
            <HowItWorksSection data-id="element-29" />
          </PageWrapper>;
      case '/privacy':
        return <PageWrapper title="Privacy Policy" data-id="element-30">
            <PrivacyPolicy data-id="element-31" />
          </PageWrapper>;
      case '/terms':
        return <PageWrapper title="Terms of Service" data-id="element-32">
            <TermsOfService data-id="element-33" />
          </PageWrapper>;
      default:
        // Home — full landing page
        return <>
            <HeroSection data-id="element-34" />
            <LocalSeoContent data-id="element-35" />
            <ResultsSection data-id="element-36" />
            <BenefitsSection data-id="element-37" />
            <HowItWorksSection data-id="element-38" />
            <ComparisonSection data-id="element-39" />
            <PoweredBySection data-id="element-40" />
            <IncludedSection data-id="element-41" />
            <DemosSection data-id="element-42" />
            <PricingSection data-id="element-43" />
            <FaqSection data-id="element-44" />
            <ContactSection data-id="element-45" />
          </>;
    }
  };
  return <div className="min-h-screen font-sans selection:bg-[#c9a84c]/30" style={{
    backgroundColor: '#050505',
    color: '#f5f5f5'
  }} data-id="element-46">
      <SchemaMarkup data-id="element-47" />
      <div className="noise-overlay" data-id="element-48"></div>
      <Header data-id="element-49" />
      <main data-id="element-50">{renderPage()}</main>
      <Footer data-id="element-51" />
    </div>;
}